import api from '@services/api'

export default {
  list(axios, params, query, config) {
    return api.get(axios, '/manager/genders', params, query, config)
  },

  get(axios, params, query, config) {
    return api.get(axios, '/manager/genders/:id', params, query, config)
  },

  create(axios, params, payload, config) {
    return api.post(axios, '/manager/genders', params, payload, config)
  },

  update(axios, params, payload, config) {
    return api.update(axios, '/manager/genders/:id', params, payload, config)
  },

  destroy(axios, params, config) {
    return api.delete(axios, '/manager/genders/:id', params, config)
  },
}
